import { App } from './app';

const scene = document.getElementById('scene') as HTMLCanvasElement;
const hud = document.getElementById('hud') as HTMLCanvasElement;
const menus = document.getElementById('menus') as HTMLElement;

const app = new App(scene, hud, menus);
app.init().catch((error: unknown) => {
  console.error(error);
  menus.hidden = false;
  menus.innerHTML = `<div class="panel center error"><div class="brand">SPACE ARENA</div><pre>${String((error as Error)?.stack ?? error)}</pre></div>`;
});
